import { apiService } from '@com.cardess/legacy-cardess-commons';

const listAvailableTimeslots = (capacityId) => {
  return apiService.get(`/capacity/capacities/${capacityId}/available-timeslots`).then((res) => res.data);
};

export default {
  listAvailableTimeslots
}
